// extracted by mini-css-extract-plugin
module.exports = {"pixel":"_xpigRu71"};